var React = require( 'react' );
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Callout = require('../../components/callout.jsx');

var PasswordResetRequest = createReactClass({
    mixins: [PureRenderMixin],

    componentWillUnmount: function(){
        this.props.clearError();
    },

    handlePasswordReset: function(event) {
        event.preventDefault();
        var email = this.refs.email.value.trim().toLowerCase();
        this.refs.email.value = '';
        this.props.createPasswordReset(email);
    },

    handlePasswordResetRequestTracking: function(event){
        var target = event.target;
        var label = target.innerText + ' - Request';
        var action = 'Click';
        this.props.recordPasswordResetClick(action, label);
    },

    render: function () {
        var error = this.props.password.error;
        var success = this.props.password.data;

        return (
            <div className="content">
                <Helmet
                    title="Forgot Password"
                    meta={[{
                        name: 'description',
                        content: 'Forgot your password for MyGiHealth? Recover it here!'
                    }]}
                />
                <div className="row">
                    <div className="x-large-6 large-6 medium-10 x-large-offset-3 large-offset-3 medium-offset-1 small-12 column end">
                        {Object.keys(error).length !== 0 &&
                            <Callout type="alert" message={error.message ? error.message : error} handleClose={this.props.clearError} />
                        }
                        {Object.keys(success).length !== 0 &&
                            <Callout type="success" message={success} handleClose={this.props.clearError} />
                        }
                        <div className="special-form-box-wrapper">
                            <div className="password-reset-get-box special-form-box">
                                <div className="header">
	                                <h1>Forgot Password</h1>
	                            </div>
                                <div className="form">
                                    <form onSubmit={this.handlePasswordReset} noValidate autoComplete="off">
                                        <div className="input-field-wrapper">
                                            <div className="input-field">
                                                <label className="heading" htmlFor="email">Email</label>
                                                <input type="email" name="email" id="email" ref="email" placeholder="john@example.com" required />
                                            </div>
                                        </div>
                                        <button className="button secondary" type="submit" onClick={this.handlePasswordResetRequestTracking}>Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = PasswordResetRequest;



// WEBPACK FOOTER //
// ./src/common/routes/password-reset/components/password-reset-request.jsx